
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import AutoCompleteField from '../../../../framework/fields/AutoCompleteField.vue';
import TextField from '../../../../framework/fields/TextField.vue';
import DateField from '../../../../framework/fields/DateField.vue';
import NumberField from '../../../../framework/fields/NumberField.vue';
import { sharedState } from '../../../../framework/state';

import { VehicleUsage } from '../../../../../common/application/model/VehicleUsage';
import { errorToast, successToast } from '../../../service/toast_service';
import { getVehicleUsage, putVehicleUsage } from '../../../client/vehicle_usage_client';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';

@Component({
    components: {
        TextField,
        ValidationObserver,
        AutoCompleteField,
        NumberField,
        DateField,
    },
})
export default class EditVehicleUsage extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.VEHICLE_USAGE;

    // Properties
    @Prop(String) readonly id!: string;

    // State
    shared = sharedState;
    local = {
        vehicleRegistrationNumber: '' as string | null,
        row: {} as VehicleUsage,
    };

    // Functions
    async mounted() {
        const vehicleUsageResponse = await getVehicleUsage(this.id);
        this.local.row = vehicleUsageResponse.vehicleUsage;
        this.local.vehicleRegistrationNumber = vehicleUsageResponse.vehicleRegistrationNumber;
    }

    save() {
        this.saveResource(false);
    }

    saveAndClose() {
        this.saveResource(true);
    }

    async saveResource(goBack: boolean) {
        try {
            await putVehicleUsage(this.local.row);
            successToast(this, 'message.vehicleUsageSaved');

            if (goBack) {
                this.back();
            }
        } catch (error) {
            errorToast(this);
        }
    }

    back() {
        this.$router.go(-1);
    }
}
